<script>
  import Link from '../../utils/link.html';
  import Menu from '../../components/navigation/menu';
  import Archive from '../../components/buttons/trash';
  import Plus from '../../components/buttons/plus';
  import Loader from '../../components/ui/loader.html';
  import { onMount, afterUpdate, getContext } from 'svelte';
  import { gql } from 'apollo-boost';
  import moment from 'moment';
  import { addNotification, ICONS } from '../../utils/notifications.store';

  import { EVENT, UPDATE_EVENT } from '../../graphql/events';

  import EventAttendees from './components/sections/event.attendees';
  import EventWaitlist from './components/sections/event.waitlist';
  import EventDetails from './components/sections/event.details';
  import EventCommunications from './components/sections/event.communications';
  import EventProgram from './components/forms/event.program';

  const client = getContext('apollo');
  const history = getContext('history');

  const components = {
    attendees: EventAttendees,
    waitlist: EventWaitlist,
    details: EventDetails,
    communications: EventCommunications,
    program: EventProgram
  };

  export let match = {};
  let loading = true;
  let event;
  let error;
  $: current = components[match.params.section] || components['attendees'];

  const menu = [
    {
      id: 'attendees',
      label: 'Attendees',
      link: `/events/view/${match.params.id}`
    },
    {
      id: 'waitlist',
      label: 'Waitlist',
      link: `/events/view/${match.params.id}/waitlist`
    },
    {
      id: 'details',
      label: 'Event Details',
      link: `/events/view/${match.params.id}/details`
    },
    {
      id: 'program',
      label: 'Program',
      link: `/events/view/${match.params.id}/program`
    },
    {
      id: 'communications',
      label: 'Communications',
      link: `/events/view/${match.params.id}/communications`
    }
  ];

  function convertTimeDate(date) {
    if (!date) {
      return null
    }

    if (date === 'Invalid date') {
      return null;
    }

    return moment(date, 'h:mm A').toDate()
  }

  async function getEvent() {
    try {
      const { data } = await client.query({
        query: EVENT,
        variables: { id: match.params.id }
      });

      if (data.event.program) {
        if (!data.event.program.secondaryCategory) {
          data.event.program.secondaryCategory = { id: null };
        }
      }

      if (!data.event.leader) {
        data.event.leader = { id: '' }
      }

      data.event.startTime = convertTimeDate(data.event.startTime);
      data.event.endTime = convertTimeDate(data.event.endTime);
      data.event.staffStartTime = convertTimeDate(data.event.staffStartTime);
      data.event.staffEndTime = convertTimeDate(data.event.staffEndTime);

      event = data.event;
      loading = false;
    } catch (e) {
      console.log(e);
      loading = false;
      error = e;
    }
  }

  function archiveEvent() {
    addNotification({
      message: `Are you sure you want to archive ${event.name
        }? It will no longer show up in the admin, but will remain available in reports.`,
      icon: ICONS.CONFIRM,
      confirm: commitArchiveEvent
    });
  }

  async function commitArchiveEvent() {
    try {
      addNotification({
        message: `Archiving ${event.name}...`,
        icon: ICONS.LOADING
      });

      await client.mutate({ mutation: UPDATE_EVENT, variables: { input: { id: event.id, archived: true } } })

      addNotification({
        message: `Archived ${event.name}`,
        icon: ICONS.SUCCESS,
        time: 2000
      });

      // history.push('/events');
      window.location = '/events'
    } catch (e) {
      console.log(e);
      addNotification({
        message: `Could not archive ${event.name}`,
        icon: ICONS.ERROR,
        time: 2000
      });
    }
  }

  function formatDate(date) {
    if (!date) return null;

    return new Date(date);
  }

  onMount(getEvent);
</script>

<style>
  .event-date {
    font-family: proxima-nova, sans-serif;
    font-weight: 300;
    color: #4c4c4b;
  }

  .event-private-label {
    background: #f3f3f3;
    padding: 4px 4px;
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    font-weight: 700;
    color: #4c4c4b;
  }

  .event-private-label a {
    color: #ff6452
  }
</style>

{#if loading}
<Loader></Loader>
{/if} {#if !loading}
{#if event.constraintPrivate}
<div>
  <h6 class="event-private-label">Private Event Link: <a
      href="https://events.thehoneycombproject.org/event/{event.id}">https://events.thehoneycombproject.org/event/{event.id}</a>
  </h6>
</div>
{/if}
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1 style="margin-bottom:4px;">{event.name}</h1>
    <h6 class="event-date">
      {moment(formatDate(event.date)).format('dddd MMMM Do, YYYY')}
    </h6>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <Archive on:click="{archiveEvent}" label="ARCHIVE EVENT"></Archive>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-12">
    <Menu active="{match.params.section || 'attendees'}" items="{menu}"></Menu>
  </div>
</div>

<svelte:component this="{current}" bind:value="{event}" id="{match.params.id}" />
{/if}